module.exports = __webpack_public_path__ + "static/media/38_B.8d5189b9.png";